// @ts-strict-ignore
import {apiClient} from 'common/util/api-client';
import {ApiResourceClient} from 'common/util/model-resource/api-resource';
import {getProjectId, getWorkspaceId} from 'common/report/util';
import {AnnotationTag} from 'common/report/model-resources/annotation-tags/types';

import {appApiUrl} from '../utils';
import {purgeFetchCache} from '../utils/fetch-cache';

function buildEndpoint({id}: {id?: string} = {}): string {
  let path = appApiUrl(`annotations/tags`, {projectId: getProjectId(), workspaceId: getWorkspaceId()});
  if (id) {
    path = `${path}${id}/`;
  }

  return path;
}

export type CreateAnnotationTagParams = Pick<AnnotationTag, `name`>;

export async function createAnnotationTag(annotationTag: CreateAnnotationTagParams): Promise<AnnotationTag> {
  return apiClient.post(buildEndpoint(), annotationTag);
}

export const annotationTagsClient: ApiResourceClient<TODO> = {
  index() {
    const annotationTagListToMap = (tags: AnnotationTag[] | null) => {
      if (!tags) {
        // annotations can be null when reading from cache
        return null;
      }
      return Object.fromEntries(tags.map((tag) => [tag.id, tag]));
    };
    const {cache, network} = apiClient.hydratedGet<AnnotationTag[]>(buildEndpoint());
    return {
      cache: cache.then(annotationTagListToMap),
      network: network.then(annotationTagListToMap),
    };
  },

  purgeCache() {
    purgeFetchCache({everything: true, path: buildEndpoint()});
  },
};
